import React from 'react'
import { motion } from 'framer-motion';
import '../css/Home.css';

function ComparisonTable() {
    const plans = [
        {
            title: 'Freelancers',
            price: 'Free',
            features: [
                'Upfront Transparent Pricing: Often unclear or hourly-based',
                'Project Kickoff Speed: Delayed based on availability',
                'Money-Back Guarantee: No refund protection',
                'Tailored Custom Software Plans: Unstructured & inconsistent',
                'Understanding of Business Logic: Limited domain understanding',
                'Speed & Efficiency: Solo bandwidth issues',
                'Scalable Architecture: Not future-ready in most cases',
                'Technology Stack: Limited to personal expertise',
                'Security & Compliance: Often overlooked',
                'Ongoing Maintenance & Support: Often ends at handoff',
                'Project Management & Communication: No formal PM',
                'Client Testimonials: Limited or none'
            ],
            highlight: false
        },
        {
            title: 'Peregrinee',
            price: '$29/mo',
            features: [
                'Upfront Transparent Pricing: Real-time calculator with one-time payment',
                'Project Kickoff Speed: Instant meeting link after payment',
                'Money-Back Guarantee: Full refund if we don’t deliver',
                'Tailored Custom Software Plans: Choose a plan based on your exact needs',
                'Understanding of Business Logic: We dig deep into your workflows & goals',
                'Speed & Efficiency: Streamlined, milestone-driven delivery',
                'Scalable Architecture: Built for growth from Day 1',
                'Technology Stack: Modern tools (React, Node, Flutter, etc.)',
                'Security & Compliance: Built-in best practices',
                'Ongoing Maintenance & Support: Included in all plans',
                'Project Management & Communication: Dedicated manager + update cycles',
                'Client Testimonials: Highly rated by clients'
            ],
            highlight: true,
            badge: 'The Best'
        },
        {
            title: 'Other companies',
            price: '$99/mo',
            features: [
                'Upfront Transparent Pricing: Requires calls before sharing estimates',
                'Project Kickoff Speed: Slower due to red tape',
                'Money-Back Guarantee: Rarely offer guarantees',
                'Tailored Custom Software Plans: But often rigid & expensive',
                'Understanding of Business Logic: Depends on account manager quality',
                'Speed & Efficiency: Slower due to hierarchy',
                'Scalable Architecture: Often offered but at a premium',
                'Technology Stack: Similar stack but less flexibility',
                'Security & Compliance: But may require extra budget',
                'Ongoing Maintenance & Support: Charged as extra service',
                'Project Management & Communication: Varies — can be overly process-heavy',
                'Client Testimonials: Can be fabricated'
            ],
            highlight: false
        }
    ];



    return (
        <>
        <motion.section id="testimonials" className="container my-5"
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: false, amount: 0.6 }}
            transition={{ duration: 0.8, ease: "easeOut" }}>
            <div className="d-flex align-items-center justify-content-center text-center flex-wrap">

                <div
                    className="px-3 fw-bold responsive-heading"
                >
                    Why  <span className="highlight-orange">Peregrinee</span> is the Better Choice for <span className="highlight-orange">Custom Software Development</span>
                </div>

            </div>
            {/* <div className="d-flex justify-content-center mt-4">
      <a
          href="#contact-us"
          className="btn custom-orange-btn py-3 px-4 fw-bold"
      >
          Book a Free Consultation
      </a>
  </div> */}

        </motion.section>
            <div className="container my-5">
                <div className="row justify-content-center g-4">
                    {plans.map((plan, index) => (
                        <motion.div
                            key={index}
                            className="col-12 col-sm-6 col-lg-4"
                            whileHover={{ scale: 1.05 }}
                            initial={{ opacity: 0, scale: 0.2 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            viewport={{ once: false, amount: 0.5 }}
                            transition={{ duration: 0.8, ease: "easeOut" }}
                        >
                            <div
                                className={`card comparison-card h-100 shadow-sm ${plan.highlight ? 'highlight-card' : ''
                                    }`}
                            >
                                <div className="card-body text-center">
                                    {plan.badge && (
                                        <div className="badge bg-warning text-dark mb-2">{plan.badge}</div>
                                    )}
                                    <h2 className="card-title fw-bold">{plan.title}</h2>
                                    {/* <h6 className="card-subtitle mb-3 text-muted">{plan.price}</h6> */}
                                    <ul className="list-unstyled mb-4 text-muted text-start fw-bold">
                                        {plan.features.map((feature, idx) => (
                                            <li key={idx} className="mb-2 py-2 feature-divider">{feature}</li>
                                        ))}
                                    </ul>
                                    {/* <button className="btn btn-outline-primary w-100 fw-bold">Choose Plan</button> */}
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </>

    )
}

export default ComparisonTable